import { xolaUri } from "../api/xolaUri";

export const getFormMediaUrl = (path: string, sellerId?: ID) => {
    const suffix = sellerId ? `?seller=${sellerId}` : ``;

    return `${xolaUri}/api${path}` + suffix;
};
